/* Route Path */
export const ROUTE_PATH = {
  root: '/',
  login: '/login',
  dashboard: '/dashboard',
  error: '/page-not-found',
  notification: {
    root: '/notification',
    anniversary: '/notification/anniversary',
    upComings: '/notification/upcoming',
  },
  orders: {
    order: '/order/booking',
    createOrder: '/order/booking/create',
    updateBooking: '/order/booking/update/:id',
    khqr: '/order/khqr',

    // Invoice
    previewInvoice: '/order/booking/preview/:id',
    updateFinal: '/order/booking/final-invoice/update/:id',

    // Payment
    payments: '/order/payment',
    updatePayment: '/order/payment/update/:id',

    // Quotations
    quotations: '/order/quotation',
    createQuotation: '/order/quotation/create',
    updateQuotation: '/order/quotation/update/:id',
    previewQuotation: '/order/quotation/preview/:id',

    // Expense
    invoices: '/order/invoices',
    updateExpense: '/order/update/:id',
    expensePreview: '/order/preview/:id',
  },

  participants: {
    customer: '/participants/customers',
    createCustomer: '/participants/customers/create',
    updateCustomer: '/participants/customers/update/:id',
    potential: '/participants/potentials',
    createPotential: '/participants/potentials/create',
    updatePotential: '/participants/potentials/update/:id',
    supplier: '/participants/suppliers',
    createSupplier: '/participants/suppliers/create',
    updateSupplier: '/participants/suppliers/update/:id',
  },
  menus: {
    root: '/menu',
    package: '/menu/package',
    food: '/menu/food',
    createFood: '/menu/food/create',
    updateFood: '/menu/food/update/:id',
    createMenuPackage: '/menu/package/create',
    updateMenuPackage: '/menu/package/update/:id',
  },
  prepareGrocery: {
    root: '/grocery',
    createGrocery: '/grocery/create',
    updateGrocery: '/grocery/update/:id',
    previewGrocery: '/grocery/preview/:id',
  },
  inventories: {
    root: '/inventory',
    product: '/inventory/product',
    units: '/inventory/unit',
    categories: '/inventory/category',
    addInventory: '/inventory/update-stock/:id',
    inventoryReport: '/inventory/reports',
  },
  users: {
    root: '/user/list',
    createNewUser: '/user/create',
    updateUser: '/user/update/:id',
    roles: '/user/role',
    createNewRole: '/user/role/create',
    updateRole: '/user/role/update/:id',
    permission: '/user/permission',
    createNewPermission: '/user/permission/create',
    updatePermission: '/user/permission/update/:id',
  },
  setting: {
    root: '/setting',
  },
};

/* Route Path API */
export const ROUTE_API = {
  baseUrl: process.env.REACT_APP_API_URL,
  // Auth
  login: '/auth/login',
  refreshToken: '/auth/verify-token',

  // Orders
  ordersList: '/orders',
  orderSave: '/orders',
  orderDelete: '/orders/delete/:id',
  orderDetail: '/orders/details/:id',
  createFinalInvoice: '/orders/final-invoice',
  exportOrders: '/orders/export',

  // Quotations
  quotationList: '/quotation',
  quotationUpsert: '/quotation',
  quotationDetail: '/quotation/:id',

  // Payments
  payments: '/payments',
  paymentDetail: '/payments/:id',
  generateKhqr: '/khqr/gen-qr',
  checkPaymentStatus: 'khqr/check-payment-status',

  // Customer
  customerList: '/customer',
  customerDetail: '/customer/:id',

  // Potential Customer
  potentialCustomersList: '/potential/list',
  potentialCustomerDetail: '/potential/:id',
  potentialCustomerAdd: '/potential/create',
  potentialCustomerUpdate: '/potential/update/:id',
  potentialCustomerDelete: '/potential/delete/:id',

  // Expense
  expense: '/expense',
  expenseDelete: '/expense/:id',
  expenseOrder: '/expense/order/:id',
  expenseOn: '/expense-on',
  expenseOnDetail: '/expense-on/:id',

  // Supplier
  suppliersList: '/supplier/list',
  suppliersDetail: '/supplier/:id',
  supplierUpdate: '/supplier/update/:id',
  SupplierDelete: '/supplier/delete/:id',
  supplierCreate: '/supplier/create',

  // Notification
  notiToday: '/notification/today',
  notiUpcoming: '/notification/upcoming',
  notiAnniversary: '/notification/anniversary',
  notiSendGift: '/notification/anniversary/update/:id',
  notiTotal: '/notification/total',

  // Dashboard
  charts: '/dashboard/charts',
  totals: '/dashboard/orders',

  // Inventory
  stockReportList: '/products/transactions',
  stockReportDetail: '/products/transactions/:id',
  inventoryUpdateStock: '/products/add-stock',

  // Unit
  unit: '/units',
  unitDetail: '/units/:id',

  // Product
  product: '/products',
  productBreakDown: '/products/break-down',
  productDetail: '/products/detail/:id',

  // Category
  category: '/category',
  categoryDetail: '/category/:id',

  // Prepare Grocery
  groceryList: '/prepare-grocery/list',
  groceryCreate: '/prepare-grocery/create',
  groceryUpdate: '/prepare-grocery/update/:id',
  groceryDetail: '/prepare-grocery/:id',
  groceryGenerate: '/prepare-grocery/generate/:id',
  groceryDelete: '/prepare-grocery/delete/:id',
  groceryValidation: '/prepare-grocery/validation/:id',
  cutStockProduct: '/inventory/cut-stock-product/:id',
  stockTotalProduct: '/inventory/total-product',

  // User
  users: '/auth/users',
  userById: '/auth/users/:id',

  // Role
  roles: '/auth/roles',
  roleById: '/auth/roles/:id',

  // Permission
  permissions: '/auth/permissions',

  // Geography
  province: '/geography/province',
  district: '/geography/district/:id',
  commune: '/geography/commune/:id',

  // Menu
  menusList: '/menus',
  menusSave: '/menus',
  menusDelete: '/menus/:id',
  menusDetail: '/menus/:id',

  // Food
  foodList: '/foods',
  foodSave: '/foods',
  foodDetail: '/foods/:id',
  foodDelete: '/foods/:id',

  // Setting
  companyProfile: '/company-profile/:id',
  updateCompanyProfile: '/company-profile/:id',

  exchangeRateDetails: '/exchange-rate/:id',
  updateExchangeRate: '/exchange-rate/update/:id',

  paymentMethods: '/payment-methods',
  paymentMethodsDetail: '/payment-methods/:id',

  eventType: '/event-type',
  eventTypeDetails: '/event-type/:id',

  // upload image
  uploadImage: '/upload-image/upload',
  getImage: '/upload-image/',
};
